// extracted by mini-css-extract-plugin
module.exports = {"section-result-container":"section-result-container_section-result-container__3eLHw"};